import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";

export default class PlayEnd extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.EndOfPlay ||
            fragment.associatedState === FootballState.NoPenaltyEndOfPlay
        );
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return [];
    }
}
